module.exports = __webpack_public_path__ + "static/media/antenna_2.29df2e66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/antenna_2.jpg
// module id = 1441
// module chunks = 0